import { render, staticRenderFns } from "./ReviewsSettingsCreateOrEditSetupCompletedTab.vue?vue&type=template&id=1364ea71&"
import script from "./ReviewsSettingsCreateOrEditSetupCompletedTab.vue?vue&type=script&lang=js&"
export * from "./ReviewsSettingsCreateOrEditSetupCompletedTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports